import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	HostBinding,
	Output,
	SimpleChanges
} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
	selector: 'welcome-step',
	templateUrl: './welcome-step.component.html',
	styleUrls: ['./welcome-step.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class WelcomeStepComponent implements OnChanges {
	private safeShowFreeTrialStep$ = new BehaviorSubject<boolean>(false);

	@Input() public data: { user: any; numDays: any };
	@Input() public showSelfPayStep: boolean;
	@Input() public loading$: Observable<boolean>;
	@HostBinding('class.free-trial') @Input() public showFreeTrialStep: boolean | undefined;
	@Output() public onProceed = new EventEmitter<void>();

	constructor () {}

	public ngOnChanges (changes: SimpleChanges) {
		// in this specific component, changes.{some-input-property} is undefined on first change (not true/false)
		if (changes.showFreeTrialStep.currentValue !== undefined) {
			this.safeShowFreeTrialStep$.next(changes.showFreeTrialStep.currentValue);
		}
	}

	public proceed (): void {
		this.onProceed.emit();
	}
}
